import { MsoSubmissionFormData } from "psims/models/submission-types/mso/mso-submission-form-data";
import { useMemo } from "react";
import { ViewMode } from "../../shared/use-view-mode";
import useProgress from "../../shared/use-progress";
import { UseMsoImporterAPI } from "./use-mso-importer-api";

interface UseMsoImporterProgressProps {
    apiCtrl: PopulatedProps<UseMsoImporterAPI, 'submission'>;
    viewMode: ViewMode;
}

function useMsoImporterProgress({apiCtrl, viewMode}: UseMsoImporterProgressProps) {
    const steps = useMemo(() => {
        return [
            {
                kind: 'data' as 'data',
                label: 'Stockholding - Importer',
                hasData: Boolean(apiCtrl.submission.submissionFormData.dataPageSaved),
            },
            {
                kind: 'submit' as 'submit',
                label: 'Declaration',
                hasData: null,
            }
        ];
    }, [apiCtrl.submission.submissionFormData.dataPageSaved]);

    const progressCtrl = useProgress({
        orderedFormDataPageSavedKeys: ['dataPageSaved'],
        steps,
        submissionFormData: apiCtrl.submission.submissionFormData as MsoSubmissionFormData,
        submissionStatus: apiCtrl.submission.dataSubmission.status,
        viewMode,
    });

    return progressCtrl;
}

export default useMsoImporterProgress

export type UseMsoImporterProgress = ReturnType<typeof useMsoImporterProgress>;
